"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var ModalVideo = /** @class */ (function () {
    function ModalVideo(documentObject) {
        var videoModal = documentObject.getElementById('videoModal');
        if (videoModal) {
            var youtubeElem_1 = videoModal.querySelector('.c-video-modal__youtube');
            var videoElem_1 = videoModal.querySelector('.c-video-modal__video');
            eventsHelper_1.default.live('.js-video-modal-trigger', eventsHelper_1.default.clickOrTouchEvent, function (event, videoModalTrigger) {
                event.preventDefault();
                if (videoModalTrigger) {
                    var videoType = videoModalTrigger.dataset.videotype;
                    var videoSrc = videoModalTrigger.dataset.video;
                    if (videoType == "Video") {
                        videoElem_1.src = videoSrc;
                        videoElem_1.classList.add('active');
                        try {
                            videoElem_1.play();
                        }
                        catch (ex) {
                            // Could not play video
                        }
                    }
                    else if (videoType == "Youtube") {
                        youtubeElem_1.src = 'https://www.youtube.com/embed/' + videoSrc + '?enablejsapi=1&autoplay=1&modestbranding=1&rel=0&controls=1&showinfo=0';
                        youtubeElem_1.parentElement.classList.add('active');
                    }
                }
            }, documentObject);
        }
    }
    ModalVideo.closeVideo = function () {
        var videoModal = document.getElementById('videoModal');
        if (videoModal) {
            var youtubeElem = videoModal.querySelector('.c-video-modal__youtube');
            var videoElem = videoModal.querySelector('.c-video-modal__video');
            videoElem.src = "";
            youtubeElem.src = "";
            videoElem.classList.remove('active');
            youtubeElem.parentElement.classList.remove('active');
        }
    };
    return ModalVideo;
}());
exports.default = ModalVideo;
